import { render } from "./PlayerIcon.vue?vue&type=template&id=3c7255f4&scoped=true&ts=true"
import script from "./PlayerIcon.vue?vue&type=script&lang=ts"
export * from "./PlayerIcon.vue?vue&type=script&lang=ts"

import "./PlayerIcon.vue?vue&type=style&index=0&id=3c7255f4&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7255f4"]])

export default __exports__